import Crono from "assets/img/Clap.png";

import "./style.scss";
import { useAuth } from "context/AuthContext";

export function Wait() {
  const { user } = useAuth();
  return (
    <>
      {/* <StepNav currentStep={3} /> */}
      {user &&
      user.detail &&
      user.detail.tipo_de_acordo === "PREDEFINIDO" &&
      (!user.detail.isBoss || !user.detail.acessor) ? (
        <div className="flex flex-col items-center justify-between mx-4 gap-9 md:flex-row md:mx-0">
          <div className="flex-1">
            <h2 className="mb-3 text-[31px] font-bold text-black-bb font-title">
            Não foi possível votar na etapa 3 do Prêmio BB </h2>
            <div className="flex flex-col gap-5 mt-16 mb-5 content">
              <p>Votam nesta etapa membros do Conselho Diretor (CD), <br/>convidados especialistas e funcionários de prefixo com iniciativa<br/> inscrita no Prêmio BB. </p>
            </div>
          </div>
          <div className="flex-1">
            <img width={"100%"} src={Crono} alt="" className="relative" />
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-between mx-4 gap-9 md:flex-row md:mx-0">
          <div className="flex-1">
            <h2 className="mb-3 text-[31px] font-bold text-black-bb font-title">
              O Prêmio BB está no ar e você participará da 1ª etapa de
              avaliação!
            </h2>
            <div className="flex flex-col gap-5 mt-16 mb-5 content">
              <p>
                No período de <b>08 a 19 de março</b>, caso a sua Unidade tenha
                uma iniciativa com selo inscrita no Prêmio BB 2024, você poderá
                participar da <b>primeira etapa de votação</b> onde serão
                escolhidas as iniciativas mais relevantes para a Unidade, dentre
                todas apresentadas.
              </p>
            </div>
          </div>
          <div className="flex-1">
            <img width={"100%"} src={Crono} alt="" className="relative" />
          </div>
        </div>
      )}
    </>
  );
}
